module.exports = "<button class=\"btn btn-default\" ng-show=\"status==='SUBSCRIBED'\">\n         <i class=\"fa fa-envelope-o\"></i>\n    Unsubscribe\n</button>\n<button class=\"btn btn-default\" ng-show=\"status==='UNSUBSCRIBED'\">\n    <i class=\"fa fa-envelope-o\"></i>\n    Subscribe\n</button>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/btn-subscription/btn-subscription.html
// module id = ./web/modern/components/buttons/btn-subscription/btn-subscription.html
// module chunks = 0